module.exports = __webpack_public_path__ + "img/产品碳流程图2.abddd681.png";